export default {
  install(Vue, { router, store, notification }) {
    if (!router) {
      throw new Error('Router instance is required for permissionGuard plugin')
    }
    if (!store) {
      throw new Error('Vuex store instance is required for permissionGuard plugin')
    }

    function hasAdminGroup() {
      const userPermissions = store.state?.applicationState?.associate?.permissions || []
      return userPermissions.some(perm => perm.group === 'administrator')
    }

    router.beforeEach((to, from, next) => {
      if (to.path === '/auth' || to.path === '/kpi') {
        return next()
      }

      if (store.state?.applicationState?.associate && !hasAdminGroup() && store.state?.applicationState?.token) {
        if (from.path === '/kpi') {
          return next(false)
        }

        next({ name: 'kpi' })

        return
      }

      next()
    })
  }
}
